<template>
  <div id="login">
    <div class="login">
      <img
        src="../assets/img/ingg.png"
        width="100"
        height="25"
        style="display: block; margin-left: auto; margin-right: auto; width: 50%; margin-bottom:10px"
      />
      <form @submit.prevent="logIn">
        <fieldset>
          <input type="text" placeholder="Usuario" v-model="Log.user_name" />
          <input
            type="password"
            placeholder="Contraseña"
            v-model="Log.user_password"
          />
        </fieldset>
        <input type="submit" value="Log In" id="log" />
      </form>
      <div class="utilities">
        <!--
        <a href="#">Forgot Password?</a>
        <a href="#">Sign Up &rarr;</a>-->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import App from "../Http";
import store from "../store/";
export default {
  name: "login",
  data: () => ({
    Log: {
      user_name: "",
      user_password: ""
    }
  }),
  mounted() {
    document.body.style.backgroundColor = "#137f4f";
  },
  methods: {
    logIn() {
      console.log("dsdsdsd")
      this.$http
        .post("User/login", {
          user_name: this.Log.user_name,
          user_password: this.Log.user_password
        })
        .then(resp => {
          store.commit("setCurrentUser", resp.data);
          App.setToken(resp.data.token);
          this.$router.push("Home");
        })
        .catch(err => {
          console.log(err.data);
        });
    }
  }
};
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/normalize/5.0.0/normalize.min.css";

.login {
  width: 375px;
  background-color: #1ea167;
  border-radius: 5px;
  padding: 20px;
  background-image: -webkit-linear-gradient(90deg, #168d59, #1ea167);
  position: absolute;
  left: 50%;
  top: 100px;
  margin-left: -187px;
  box-shadow: 0px 1px 0px rgba(255, 255, 255, 0.2) inset,
    0px 0px 2px rgba(0, 0, 0, 0.5);
}
.login h2 {
  color: white;
  font-size: 20px;
  margin: 0 0 15px;
  text-shadow: 0px -1px rgba(0, 0, 0, 0.5);
}
.login fieldset {
  border: 0;
  padding: 0;
  margin-bottom: 10px;
}
.login fieldset input {
  outline: none;
  width: 330px;
  height: auto;
  display: block;
  background: #138050;
  border: 1px solid #0d6b42;
  margin: 0;
  padding: 13px 15px;
  font-size: 13px;
}
.login fieldset input:focus,
.login fieldset input:active {
  background-color: #1ea167;
}
.login fieldset input:nth-child(1) {
  border-radius: 5px 5px 0 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1) inset;
}
.login fieldset input:nth-child(2) {
  position: relative;
  top: -1px;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1) inset,
    0 1px 0 rgba(255, 255, 255, 0.4);
}
.login fieldset ::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.login input[type="submit"] {
  margin: 0;
  display: block;
  padding: 13px 0;
  width: 335px;
  font-size: 13px;
  font-weight: bold;
  border: 0;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 1);
  background-color: #f6ba35;
  background-image: -webkit-linear-gradient(90deg, #eca418, #ffcd4e);
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}
.login input[type="submit"]:hover {
  margin: 0;
  display: block;
  padding: 13px 0;
  width: 335px;
  font-size: 13px;
  font-weight: bold;
  border: 0;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 1);
  background-color: #f6ba35;
  background-image: -webkit-linear-gradient(
    top,
    rgba(252, 234, 187, 1) 0%,
    rgba(252, 205, 77, 1) 9%,
    rgba(248, 181, 0, 1) 25%,
    rgba(102, 86, 46, 1) 100%
  );
  border-radius: 5px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}
.login .utilities {
  margin-top: 20px;
}
.login .utilities a {
  color: #61e5ab;
  text-decoration: none;
  font-size: 12px;
  text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.4);
}
.login .utilities a:hover {
  color: white;
}
.login .utilities a:nth-child(2) {
  display: block;
  float: right;
  width: 50%;
  text-align: right;
}
.login:before,
.login:after {
  z-index: -1;
  position: absolute;
  content: "";
  left: 5px;
  width: 53%;
  top: 15px;
  height: 80%;
  bottom: 80%;
  max-width: 300px;
  background: rgba(0, 0, 0, 0.7);
  box-shadow: -10px -15px 20px rgba(0, 0, 0, 0.2);
  -webkit-transform: rotate(-3deg);
}
.login:after {
  box-shadow: 10px -15px 20px rgba(0, 0, 0, 0.2) !important;
  -webkit-transform: rotate(3deg);
  right: 5px;
  left: auto;
}
</style>
